/* eslint-disable camelcase */
import { useContext } from 'react';

import { AppContext } from 'context/app';
import { ConfigContext } from 'context/config';
import { logAspenEvent } from 'modules/aspenLogger';

export const useAspenLogger = () => {
  const { endpoints } = useContext(ConfigContext);
  const { userId, appSessionId } = useContext(AppContext);
  const aspenLogsEndpoint = endpoints.aspen_logs;

  const logAspenEventWithPayload = logAspenEvent(aspenLogsEndpoint, {
    account_id: userId,
    web_session_id: appSessionId,
  });

  return { logAspenEvent: logAspenEventWithPayload };
};
